import React from "react";
import "./header.css"

const Header = () => {
  return (
    <div className='pa2'>
     
    <div className="bg-white black-80 tc pv4 avenir">
 
  <h1 className="mt2 mb0 baskerville i fw1 f1">Florida lotto scratch-off tickets</h1>
  <h2 className="mt2 mb0 f6 fw4 ttu tracked">Let's find the best ticket to buy today</h2>
  <div className="bt bb tc mw7 center mt4">
    {/* <a class="f6 f5-l link bg-animate black-80 hover-bg-lightest-blue dib pa3 ph4-l" href="/">Home</a>
    <a class="f6 f5-l link bg-animate black-80 hover-bg-light-green dib pa3 ph4-l" href="/portfolio">Portfolio</a>
    <a class="f6 f5-l link bg-animate black-80 hover-bg-light-blue dib pa3 ph4-l" href="/shop">Shop</a>
    <a class="f6 f5-l link bg-animate black-80 hover-bg-light-pink dib pa3 ph4-l" href="/about">About</a>
    <a class="f6 f5-l link bg-animate black-80 hover-bg-light-yellow dib pa3 ph4-l" href="/contact">Contact</a> */}
  </div>
</div>
    </div>
  );
};

export default Header;
